declare namespace $ {

	type $mol_button_minor__hint_bog_music_tube_row_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_tube_row_2 = $mol_type_enforce<
		ReturnType< $bog_music_tube_row['play'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_tube_row_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_image__uri_bog_music_tube_row_4 = $mol_type_enforce<
		ReturnType< $bog_music_tube_row['cover'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__event_bog_music_tube_row_5 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_music_tube_row['play'] > ): ReturnType< $bog_music_tube_row['play'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_tube_row_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_tube_row_7 = $mol_type_enforce<
		ReturnType< $bog_music_tube_row['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_music_tube_row_8 = $mol_type_enforce<
		ReturnType< $bog_music_tube_row['subtitle'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__event_bog_music_tube_row_9 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_music_tube_row['play'] > ): ReturnType< $bog_music_tube_row['play'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_tube_row_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_tube_row_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_music_tube_row_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_tube_row_13 = $mol_type_enforce<
		ReturnType< $bog_music_tube_row['get'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_tube_row_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_music_tube_row extends $mol_view {
		play( next?: any ): any
		Play_icon( ): $mol_icon_play
		Play( ): $mol_button_minor
		Cover( ): $mol_image
		Cover_placeholder( ): $mol_icon_music
		Cover_box( ): $mol_view
		Title( ): $mol_paragraph
		Subtitle( ): $mol_paragraph
		Info( ): $mol_view
		Status( ): $mol_view
		get( next?: any ): any
		Get_icon( ): $mol_icon_download
		Get( ): $mol_button_minor
		title( ): string
		subtitle( ): string
		status( ): string
		cover( ): string
		playing( ): boolean
		busy( ): boolean
		attr( ): ({ 
			'bog_music_tube_row_busy': ReturnType< $bog_music_tube_row['busy'] >,
		}) 
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=row.view.tree.d.ts.map